import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 登录服重载
const loginReloadAll = obj => new Promise((resolve, reject) => {
    const {
        reloadForm,
        token
    } = obj;
    request({
        url: apis.login_reload_all + '?token=' + token,
        data: reloadForm
    }).then(res => {
        resolve(res);
    })
});

// 登录服全部重载
const loginReloadConfig = obj => new Promise((resolve, reject) => {
    const {
        reloadForm,
        token
    } = obj;
    request({
        url: apis.login_reload_config + '?token=' + token,
        data: reloadForm
    }).then(res => {
        resolve(res);
    })
});

const reloadAllClzName = obj => new Promise((resolve, reject) => {
    const {
        reloadForm,
        token
    } = obj;
    request({
        url: apis.login_reload_all_clzName + '?token=' + token,
        data: reloadForm
    }).then(res => {
        resolve(res);
    })
});

export default {
    loginReloadAll,
    loginReloadConfig,
    reloadAllClzName
}



// WEBPACK FOOTER //
// ./src/service/login_api.js